/**
 * @md : https://www.yuque.com/docs/share/28865c95-4368-4464-8162-a0535a98712f?# 《Router模块》
 */

import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import routerConfig from './router.config'
import routerList from './src'
import { loadRouter } from './loadRouter'
Vue.use(VueRouter)
const router = new VueRouter({
  base: process.env.VUE_APP_PUBLIC_PATH,
  routes: Object.values(routerList).concat(routerConfig.defaultRouter),
  mode: 'history'
})
const whiteRouteUrl = routerConfig.whiteRouteUrl
// 动态路由
router.beforeEach((to, from, next) => {
  NProgress.start()
  // console.log('to', to)
  // 默认需要授权
  const auth = typeof to.meta.auth == 'undefined' ? true : to.meta.auth

  if (whiteRouteUrl.indexOf(to.path) > -1) {
    next()
  } else if (store.getters.menus.length == 0) {
    loadRouter().then((res) => {
      router.addRoutes(res)
      next({ ...to })
    })
  } else {
    next()
  }
})

router.afterEach((to, from, next) => {
  if (to.path == '/auth/login' || to.path == '/auth/phoneLogin') {
    store.commit('setGlobalHeader', false)
  } else {
    store.commit('setGlobalHeader', true)
  }
  //进度条消失
  NProgress.done()
})

export default router
